import React from 'react';
import CreatableSelect from 'react-select/creatable';

const SingleSelectDropdown = ({ options, value, onChange, placeholder = "Select or create...", disabled = false }) => {
  return (
    <CreatableSelect
      isClearable
      isDisabled={disabled}
      options={options}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      menuPortalTarget={document.body}
      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
    />
  );
};

export default SingleSelectDropdown;
